












































import { defineComponent, computed, watch } from '@vue/composition-api';
import { useDiscussionMessageStore } from '@front-app/store/piniaModules/discussionMessages';
import { syncedRef } from '@front-app/util/reactivity';
import { v } from '@front-app/components/form/validation/useValidation';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { useFocusFirstInvalidField } from '@front-app/hooks/useFocusFirstInvalidField';
import TrForm from '@front-app/components/form/Form.vue';
import RichTextSection from '../form/RichTextSection.vue';
import SlidingPanel from '../modals/SlidingPanel.vue';
import CtaButton from '../buttons/CtaButton.vue';
import ErrorCard from '../cards/state/ErrorCard.vue';
import SuccessCard from '../cards/state/SuccessCard.vue';
import { ButtonPalettes } from '../buttons/palettes';
import { Size } from '../constants';
import { required } from '../form/validation/validators';
import { EMPTY_MESSAGE } from '../form/tiptap/useTiptapEditor';

export default defineComponent({
	components: {
		SlidingPanel,
		TrForm,
		RichTextSection,
		CtaButton,
		ErrorCard,
		SuccessCard,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		messageId: {
			type: String,
			default: '',
		},
		backButtonText: {
			type: String,
			required: true,
		},
		isOpen: Boolean,
	},
	setup(props) {
		const discussionMessageStore = useDiscussionMessageStore();
		const storedPostContent = computed(() => discussionMessageStore.getById(props.messageId)?.messageText);
		const postContent = syncedRef(storedPostContent).ref;

		const validation = v({
			postContent: {
				value: postContent,
				rules: [required([EMPTY_MESSAGE])],
			},
		});

		const postContentErrorText = computed(() => {
			if (!validation.isValid.value) {
				return 'discussion.edit-post.empty-post-content-error';
			}
			return '';
		});

		const {
			clear: resetSubmissionStatus,
			track: trackSubmission,
			isLoading: isSubmitting,
			isSuccess: isSuccessSubmitting,
			isError: hasErrorSubmitting,
		} = useAsyncStatus();
		const { focusFirstInvalid } = useFocusFirstInvalidField({ containerSelector: '#edit-discussion-message-form' });
		const handleSubmit = async () => {
			validation.validate();
			if (!validation.isValid.value) {
				focusFirstInvalid();
				return;
			}
			await trackSubmission(discussionMessageStore.edit(props.messageId, {
				messageText: postContent.value,
			}));
		};

		watch(() => props.isOpen, (isOpen) => {
			if (!isOpen) {
				resetSubmissionStatus(0);
			}
		});

		return {
			handleSubmit,
			isSubmitting,
			isSuccessSubmitting,
			hasErrorSubmitting,
			storedPostContent,
			postContent,
			postContentErrorText,
			// Util
			submitButtonPalette: ButtonPalettes.PRIMARY,
			submitButtonSize: Size.LARGE,
		};
	},
});
